





















import { defineComponent, PropType } from '@vue/composition-api';
import { formatValue } from '@/common/util';
import { sendClickLog } from '@/common/log';
import { callApp, CallAppOption } from '../../utils';

import { InteractInfo } from '../../type';

import likeIcon from '@/assets/images/like.png';
import favoriteIcon from '@/assets/images/bookmark.png';
import commentIcon from '@/assets/images/comment.png';

export default defineComponent({
    props: {
        interactInfo: {
            type: Object as PropType<InteractInfo>,
            default: () => ({}),
        },
        callAppOption: {
            type: Object as PropType<CallAppOption>,
            default: () => ({}),
        },
    },
    setup(props) {
        const config = [
            {
                key: 'likedCount',
                icon: likeIcon,
                click_type: 'like',
            },
            {
                key: 'favoriteCount',
                icon: favoriteIcon,
                click_type: 'save',
            },
            {
                key: 'commentCount',
                icon: commentIcon,
                click_type: 'comment',
            },
        ];

        function handleClickBtn(click_type: string) {
            sendClickLog({
                name: 'INTERACTION_BUTTON',
                value: {
                    click_type,
                },
            });
            callApp(props.callAppOption);
        }

        return {
            props,
            formatValue,
            callApp,
            handleClickBtn,

            config,
        };
    },
});
